import { ILanguage } from "../types";

export const de: ILanguage = {
  translation: {
    root: {
      customize: "Anpassen",
      businessAccount: "Geschäftskonto",
      verificationStatus: "Überprüfungsstatus",
      companyInformation: "Unternehmensinformationen",
      note: "Notiz",
      businessName: "Firmenname*",
      enterBusinessName: "Geben Sie den Geschäftsnamen ein",
      registrationNumber: "Firmenreg. ",
      registrationNumberPlaceholder: "Geben Sie die Registrierungsnummer ein",
      taxVat: "Steuer-/Mehrwertsteuer -Registrierung Nr.",
      vatPlaceholder:
        "Geben Sie die Steuer-/Mehrwertsteuer -Registrierungsnummer ein",
      registeredAddress: "Registrierte Adresse*",
      tradingAddress: "Handelsadresse*",
      sameAsRegisteredAddress: "Gleich wie eine registrierte Adresse",
      billingInformation: "Abrechnungsdaten",
      mode: "Modus",
      comments: "Kommentare",
      billingPhoneNo: "Rechnungstelefon Nr.*",
      phonePlaceholder: "Telefonnummer eingeben",
      middleName: "Zweiter Vorname",
      middleNameLabel: "Zweiter Vorname",
      enterMiddleName: "Zweiten Vornamen eingeben",
      billingEmail: "Abrechnungs -E -Mail*",
      emailPlaceholder: "Geben Sie die Abrechnungs -E -Mail ein",
      driverDetails: "Fahrerdetails",
      customerVerificationStatus: "Kundenüberprüfungsstatus:",
      enterNationalInsuranceNumber: "Nationalversicherungsnummer eingeben",
      enterYourProfession: "Geben Sie Ihren Beruf ein",
      enterDriving: "Fahren Sie Fahren ein",
      profileImage: "Profilbild",
      number: "Nummer",
      image: "Bild",
      uploadBack: "Laden Sie zurück",
      uploadFront: "Front hochladen",
      issuedBy: "Ausgestellt von",
      document: "Dokumentieren",
      selectDocument: "Dokument auswählen",
      addFile: "Datei hinzufügen",
      noDataFound: "Keine Daten gefunden",
      noDocumentsFound: "Keine Dokumente gefunden",
      documentUpdatedAt: "Dokument aktualisiert at",
      editExpiryDate: "Ablaufdatum bearbeiten",
      selectExpiryDate: "Wählen Sie das Ablaufdatum",
      selectExpiryDateUpload:
        "Bitte wählen Sie vor dem Hochladen ein Ablaufdatum.",
      status: "Status",
      images: "Bilder",
      profession: "Beruf",
      nationality: "Staatsangehörigkeit",
      driving: "Fahren",
      listOfDocumentsUploaded: "Liste der hochgeladenen Dokumente",
      listOfRequiredDocumentsUploaded:
        "Liste der erforderlichen Dokumente hochgeladen",
      documentType: "Dokumenttyp",
      documentName: "Dokumentname",
      expiryDate: "Verfallsdatum",
      confirmDelete: "Bestätigen Sie löschen",
      actions: "Aktionen",
      completed: "Vollendet",
      pending: "Ausstehend",
      documentDeleteConfirmMsg:
        "Sind Sie sicher, dass Sie dieses Dokument löschen möchten?",
      billingEmailAddress: "Abrechnungs -E -Mail -Adresse*",
      billingEmailLabel: "Abrechnungs -E -Mail -Adresse",
      accountNumber: "Kontonummer",
      firstName: "Vorname*",
      lastName: "Nachname*",
      lastNameLabel: "Nachname",
      contactEmail: "Wenden Sie sich an E -Mail -Adresse*",
      emailLabel: "E-Mail-Adresse",
      contactPhone: "Kontaktieren Sie Telefonnummer*",
      registeredAddressCaps: "Registrierte Adresse",
      tradingAddressCaps: "Handelsadresse",
      billingInformationCaps: "ABRECHNUNGSDATEN",
      customerContactCaps: "Kundenkontakt",
      contactEmailInvalid: "Bitte geben Sie eine gültige Kontakt -E -Mail ein.",
      address: "Adresse",
      useRegisteredAddress: "Verwenden Sie die registrierte",
      drivingLicenceNumber: "Führerscheinnummer",
      invalidPhoneNumber: "Ungültige Telefonnummer",
      firstNameLabel: "Vorname",
      typeAddress: "Geben Sie die Adresse ein",
      taxFees: "Steuern und Gebühren",
      vatTax: "Mehrwertsteuer/Steuer",
      registrationNum: "Registrierungsnummer",
      onStartEmail:
        "Wir haben Ihnen eine E -Mail geschickt, wie Sie loslegen können.",
      emailNotSeen:
        'Wenn Sie die E -Mail in wenigen Minuten nicht sehen, überprüfen Sie Ihre "Junk -Mail" oder "Spam -Ordner.',
      registerNow: "Jetzt registrieren",
      email: "E-Mail",
      thankYou: "Danke",
      pickUpLocation: "Abholort ",
      returnLocation: "Rückgabeort *",
      pickUpDate: "Abholdatum *",
      pickUpTime: "Abholzeit *",
      invalidPickupLeadTime: "Das ausgewählte Abholdatum/-uhrzeit liegt außerhalb des zulässigen Buchungszeitraums",
      dropOffDate: "Rückgabedatum *",
      searchVehicles: "Fahrzeuge suchen",
      chooseLocation: "Geben Sie einen Ort oder eine Postleitzahl ein",
      vehicleGallery: "Fahrzeuggalerie",
      privacyPolicy: "Datenschutzrichtlinie",
      termsAndConditions: "Allgemeine Geschäftsbedingungen",
      dropOffTime: "Rückgabezeit *",
      noVehiclesFound:
        "Keine Fahrzeuge gefunden, die den ausgewählten Kriterien entsprechen",
      noRecordFound: "Entschuldigung, keine passenden Einträge gefunden!",
      vehicles: "Fahrzeuge",
      endDate: "Enddatum",
      startDate: "Startdatum",
      past: "Vergangenheit",
      search: "Suchen",
      upcoming: "Bevorstehend",
      current: "Aktuell",
      all: "Alle",
      more: "Mehr",
      toBeAssigned: "Noch zugewiesen",
      ref: "Ref",
      reservation: "Reservierung",
      booking: "Buchung",
      pricingSummary: "Preisübersicht",
      bookingSummary: "Buchungsübersicht",
      subscriptionVehicle: "Abonnementfahrzeug",
      insurance: "Versicherung",
      addons: "Zusatzoptionen",
      protectionPlan: "Schutzplan",
      initialRental: "Erste Mietzahlung",
      enrollmentFee: "Anmeldegebühr",
      quantity: "Menge",
      subscriptionPrice: "Abonnementpreis",
      weekly: "Wöchentlich",
      monthly: "Monatlich",
      on: "Am",
      numberOfDoors: "Anzahl der Türen",
      numberOfSeats: "Anzahl der Sitze",
      transmission: "Getriebe",
      fuelType: "Kraftstoffart",
      week: "Woche",
      day: "Tag",
      hour: "Stunde",
      month: "Monat",
      gropu1Icon: "Gruppe1-Symbol",
      vatInclusive: "MwSt. INKLUSIVE",
      vat: "MwSt.",
      rental: "Miete",
      speedometer: "Tachometer",
      available: "Verfügbar",
      priceLowToHigh: "Preis aufsteigend",
      priceHighToLow: "Preis absteigend",
      weHaveSmartCars: "Wir haben intelligente Autos",
      keylessSupport:
        "Wir bieten schlüssellosen Zugang mit unseren intelligenten Autos",
      keylessVehicles: "Schlüssellose Fahrzeuge anzeigen",
      duration: "Dauer",
      swapsAllowed: "Wechsel erlaubt",
      enrollmentAmount: "Anmeldebetrag",
      subscriptionAmount: "Abonnementbetrag",
      mileageLimit: "Kilometerbegrenzung",
      unlimited: "Unbegrenzt",
      weeks: "Wochen",
      months: "Monate",
      pricePerExtraMile: "Preis pro zusätzlichem Kilometer",
      insurancePolicy: "Versicherungspolice",
      removeSubscription: "Abonnement entfernen",
      noGroupFound: "Keine Gruppen mit passenden Kriterien gefunden!",
      vehicleTypeIcon: "Fahrzeugtyp-Symbol",
      min: "Min",
      selected: "Ausgewählt",
      vehiclesSelected: "Fahrzeuge ausgewählt",
      selectVehicles: "Fahrzeuge auswählen",
      personalDetails: "Persönliche Angaben",
      selectAddons: "Zusatzoptionen auswählen",
      continue: "Fortfahren",
      locationSurcharge: "Standortzuschlag",
      onTotalRentalAmount: "Auf Gesamtmietbetrag",
      oneWayFee: "Einweggebühr",
      oneWayRentalCharge: "Einwegmietgebühr",
      total: "Gesamt",
      firstMonthTotal: "Gesamtbetrag erster Monat",
      firstWeekTotal: "Gesamtbetrag erste Woche",
      depositPayable: "Kaution (zahlbar bei Abholung)",
      deposit: "Kaution",
      insuranceCaps: "VERSICHERUNG",
      customAddon: "Benutzerdefiniertes Add-on",
      chooseAPolicy: "Wählen Sie eine Police",
      rate: "Rate",
      typeOfValet: "Art des Valet",
      nonNegotiable: "Nicht verhandelbar",
      selectValet: "Valet auswählen",
      collectionAddress: "Abholadresse",
      remove: "Entfernen",
      deliveryAddress: "Lieferadresse",
      additionalInformation: "Zusätzliche Informationen",
      confirmBooking: "Buchung bestätigen",
      proceed: "Weiter",
      getQuote: "Angebot einholen",
      for: "für",
      agreeWithTermsAndConditions:
        "Ich stimme den Allgemeinen Geschäftsbedingungen zu",
      selectCostCenter: "Kostenstelle für Buchung auswählen",
      action: "Aktion",
      name: "Name",
      enterDrivingLicenceNumber: "Führerscheinnummer eingeben",
      enterLastName: "Nachnamen eingeben",
      enterFirstName: "Vornamen eingeben",
      enterYourMail: "E-Mail eingeben",
      emailAsterisk: "E-Mail*",
      quoteGeneratedCaps: "ANGEBOT ERSTELLT",
      updated: "Aktualisiert",
      rentalCharges: "Mietgebühren",
      totalPayableAmount: "Gesamtzahlungsbetrag",
      payMinimumAmount: "Mindestbetrag zahlen",
      dueAmountPaidWhilePickup: "Fälliger Betrag bei Abholung zu zahlen",
      payOnCollection: "Bei Abholung zahlen",
      CardAuthorization:
        "Karte wird jetzt autorisiert, Betrag wird abgebucht, wenn",
      starts: "beginnt",
      confirm: "Bestätigen",
      payAtTimeOfPickup: "jetzt und bei Abholung zahlen",
      payFullAmountNow: "Gesamtbetrag jetzt zahlen",
      payFullAmountRightAway: "Gesamtbetrag sofort zahlen",
      FutureChargesRelatedToOngoingBooking:
        "Zukünftige Gebühren im Zusammenhang mit der laufenden Buchung werden dieser Zahlungsmethode belastet",
      saveThisCardForFutureInvoices:
        "Diese Karte für zukünftige Rechnungen speichern {{bookingSyntax}}",
      payLater: "Später zahlen",
      creditLimitAssigned:
        "Zugewiesenes Kreditlimit für dieses Unternehmen wird für diese Zahlung verwendet",
      CreditsAgainstBooking:
        "Gutschriften werden gegen diese Buchung verwendet",
      useCreditNoteBalance: "Guthaben aus Gutschrift verwenden",
      telNo: "Tel.-Nr.",
      vatNo: "USt.-ID",
      customer: "Kunde",
      emailAddress: "E-Mail-Adresse",
      phoneNumber: "Telefonnummer",
      dateCreated: "Erstellungsdatum",
      poNumber: "Bestellnummer",
      dateTime: "Datum & Uhrzeit",
      dropOffLocation: "Abgabeort",
      contractHire: "Vertragsmiete",
      subscription: "Abonnement",
      charges: "Gebühren",
      enrollmentFees: "Anmeldegebühren",
      na: "N/V",
      grandTotal: "Gesamtsumme",
      rentalPrice: "Mietpreis",
      daysProRated: "Tage anteilig berechnet",
      locationSurcharges: "Standortzuschläge",
      ofTotalRentalAmount: "des Gesamtmietbetrags",
      nextBilling: "Nächste Abrechnung",
      subTotal: "Zwischensumme",
      discount: "Rabatt",
      discountedPrice: "Ermäßigter Preis",
      description: "BESCHREIBUNG",
      descriptionLabel: "Beschreibung",
      thisIsA: "Dies ist ein",
      exemptedBooking: "ausgenommene Buchung",
      thisIstestCourtsey: "Dies ist ein Test/Höflichkeit",
      isCalculatedAgainst: "wird berechnet gegen",
      priceAndSelectedAddons:
        "Preis und einige ausgewählte Add-ons ohne Versicherung und Kaution",
      recurringWeeklyMonthlyInvoice:
        "Eine wiederkehrende wöchentliche/monatliche Rechnung wird automatisch für die nächste Woche/den nächsten Monat erstellt.",
      additionalNote: "Zusätzliche Notiz",
      payableAtVehicleCollection: "Zahlbar bei Fahrzeugabholung",
      purchaseOrderUpdated: "Bestellnummer erfolgreich aktualisiert",
      proceedToPay: "Zur Zahlung fortfahren",
      searchResults: "Suchergebnisse",
      subscriptions: "Abonnements",
      contractHireVehicleWeeklyMonthly:
        "Mietfahrzeug für wöchentliche/monatliche Nutzung",
      subscribeVehicleWeeklyMonthly:
        "Fahrzeug für wöchentliche/monatliche Nutzung abonnieren",
      contractNow: "Jetzt mieten",
      subscribeNow: "Jetzt abonnieren",
      backToBookingCategorySelection:
        "Zurück zur Auswahl der Buchungskategorien.",
      accountVerification: "Kontoverifizierung",
      profileNotVerifiedMessage:
        "Ihr Profil wurde nicht verifiziert. Bitte kontaktieren Sie Ihren Betreiber, um den Verifizierungsprozess abzuschließen und fortzufahren.",
      update: "Aktualisierung",
      reference: "Referenz",
      companyRegistrationNumber: "Handelsregisternummer",
      availableFrom: "Verfügbar ab",
      paellaDish: "Paella-Gericht",
      vehicleCatalogues: "Fahrzeugkataloge",
      vehicleDetails: "Fahrzeugdetails",
      verification: "Verifizierung",
      protectionPlans: "Schutzpläne",
      authorisedSignatory: "Befugter Unterzeichner",
      item: "Artikel",
      price: "Preis",
      unitPrice: "Stückpreis",
      vehicleSpecification: "Fahrzeugspezifikation",
      model: "Modell",
      color: "Farbe",
      bodyType: "Karosserietyp",
      tankCapacity: "Tankkapazität",
      interiorColor: "Innenfarbe",
      seats: "Sitze",
      doors: "Türen",
      whatsIncluded: "Was ist enthalten",
      timeVehicleSwap: "Fahrzeugwechselzeit",
      contractualDetails: "Vertragsdetails",
      longerSubscribeSaveMore:
        "Je länger Sie abonnieren, desto mehr sparen Sie",
      tailorSubscriptionToNeeds:
        "Passen Sie Ihr Abonnement an Ihre Bedürfnisse an",
      easyManagementOnline: "Einfache Online-Verwaltung",
      SwapCarAndCancel: "Auto wechseln oder jederzeit kündigen",
      customizeYourContract: "Passen Sie Ihren Vertrag an",
      selectPlan: "Plan auswählen",
      selectTenure: "Laufzeit auswählen",
      tentativeStartDate: "Voraussichtliches Startdatum",
      selectDate: "Datum auswählen",
      selectTime: "Uhrzeit auswählen",
      contractSummary: "Vertragsübersicht",
      subscriptionChargesLabel: "Abonnementgebühren",
      initialRentalPayment: "Erste Mietzahlung",
      continueToPersonalDetails: "Weiter zu persönlichen Angaben",
      noAvailableAddonsFound:
        "Keine verfügbaren Add-ons entsprechen Ihren Suchkriterien",
      nationalInsuranceNumber: "Nationalversicherungsnummer",
      updateQuote: "Angebot aktualisieren",
      driverNotAvailable:
        "Fahrer ist nicht verfügbar, bitte wenden Sie sich an den Vermieter",
      selectDeliverySlot: "Lieferzeitfenster auswählen",
      wantDelivered: "Möchten Sie die Lieferung?",
      verifyYourLicenceCaps: "FÜHRERSCHEIN VERIFIZIEREN",
      validateAllFieldsForLicenceCheck:
        "Bitte validieren oder geben Sie die folgenden Daten ein, um die Führerscheinprüfung durchzuführen. Alle Felder sind Pflichtfelder.",
      postCode: "Postleitzahl",
      thisAgreementAllows: "Diese Vereinbarung erlaubt",
      leftoverAgreement:
        "unserem Versicherungspartner, Überprüfungen Ihres Führerscheins durchzuführen und die von Ihnen bereitgestellten Daten an Versicherer und andere relevante Dritte (Coastr) zur Verwaltung Ihrer Fahrzeugmiete, Versicherungspolice usw. weiterzugeben. Stimmen Sie dem zu?",
      verifyLicence: "Führerschein verifizieren",
      licenceCheckingInProgress: "Führerscheinprüfung läuft",
      checkingInProgress:
        "Dies kann bis zu 2 Minuten dauern, bitte warten Sie und schließen Sie den Browser nicht",
      licenceCheckingFailed: "Führerscheinprüfung fehlgeschlagen",
      checkForCorrectDetails:
        "Bitte überprüfen Sie, ob Sie die richtigen Daten eingegeben haben.",
      tryAgainLater:
        "Wenn das Problem weiterhin besteht, versuchen Sie es bitte später erneut.",
      licenceCheckedSuccessfully: "Führerschein erfolgreich überprüft",
      licenceSummaryAdded:
        "Führerscheinzusammenfassung zum Kundenprofil hinzugefügt",
      creditScore: "Kreditscore",
      lastChecked: "Zuletzt geprüft",
      recheckCreditScore: "KREDITSCORE ERNEUT PRÜFEN",
      checkCreditScore: "KREDITSCORE PRÜFEN",
      proceedToPayment: "Zur Zahlung fortfahren",
      paymentOverview: "Zahlungsübersicht",
      schedule: "Zeitplan",
      contractDetails: "Vertragsdetails",
      plan: "Plan",
      swaps: "Tauschvorgänge",
      payableDeposit: "Zu zahlende Kaution",
      customerVerification: "Kundenverifizierung",
      provideAdditionalDetails:
        "Bitte geben Sie die folgenden zusätzlichen Informationen im Kontobereich an, um eine Buchung zu erstellen",
      profilePhoto: "Profilfoto",
      submitYourRequest:
        "Sobald Sie fertig sind, senden Sie bitte Ihre Anfrage zur Genehmigung, indem Sie unten auf die Schaltfläche 'Senden' klicken",
      submit: "Absenden",
      uploadLicenceImages: "Führerscheinbilder hochladen",
      add: "Hinzufügen",
      uploadFrontBackLicence:
        "Vorder- und Rückseite des Führerscheins hochladen. Unterstützte Dateiformate: .png, .jpeg, .jpg!",
      uploadLicenceImage: "Führerscheinbild hochladen",
      authority: "Behörde",
      drivingLicenceExpiryDate: "Ablaufdatum des Führerscheins",
      licenceNumber: "Führerscheinnummer",
      preview: "Vorschau",
      addOn: "Zusatz",
      contact: "Kontakt",

      selectSlot: "Slot auswählen",
      deliveryType: "Lieferart",
      experience: "Erlebnis",
      type: "Typ",
      bookATestDrive: "Probefahrt buchen",
      selectASlot: "Einen Slot auswählen",
      selectDateTimeSlot: "Datum und Uhrzeit auswählen",
      vehicleNotAvailable: "Fahrzeug für das gewählte Datum nicht verfügbar",
      selectDifferentDate: "Bitte wählen Sie ein anderes Datum",
      selectCar: "Ein Auto auswählen",
      availableNow: "Jetzt verfügbar",
      new: "Neu",
      phone: "Telefon",
      customerDetails: "Kundendaten",
      dealershipAddress: "Händleradresse",
      dealership: "Händler",
      bookingTime: "Buchungszeit",
      bookingType: "Buchungstyp",
      details: "Details",
      your: "dein",
      confirmation: "Bestätigung",
      selectDealership: "Händler auswählen",
      testDriveRequested: "Probefahrt angefordert",
      testDrive: "Probefahrt",
      mobileNumber: "Handynummer",
      drivingLicenseNumber: "Führerscheinnummer",
      enterLicenseNumber: "Führerscheinnummer eingeben",
      requestTestDrive: "Probefahrt anfordern",
      slot: "Slot",
      vehicle: "Fahrzeug",
      selectSubsctiption: "ABONNEMENT WÄHLEN",
      pricesShownOnSelectedDuration:
        "Angezeigte Preise basieren auf der ausgewählten Dauer",
      priceComparison: "Preisvergleich",
      oneTime: "Einmalig",
      subscriptionStartsAt: "Abonnement beginnt bei",
      paymentProcessing: "Zahlung wird verarbeitet",
      pleaseWait: "Bitte warten",
      paymentComplete: "Zahlung abgeschlossen",
      paymentInProgress: "Zahlung läuft",
      atleastUploadOne: "Mindestens eine Datei hochladen",
      upload: "Hochladen",
      uploadServiceNotAvailable: "Upload-Dienst nicht verfügbar. Bitte versuchen Sie es erneut.",
      uploading: "Wird hochgeladen...",
      atDealership: "Beim Autohaus",
      atHome: "Zuhause",

      enterYourEmailPassword:
        "Geben Sie Ihre E‑Mail und Ihr Passwort ein, um sich anzumelden",
      enterMailHere: "Geben Sie hier Ihre E‑Mail ein",
      required: "Erforderlich",
      password: "Passwort",
      reset: "Zurücksetzen",
      otpForPasswordReset:
        "Sie erhalten einen OTP zur Passwortzurücksetzung per E‑Mail",
      sendOtp: "OTP senden",
      loginInstead: "Stattdessen anmelden",
      verifyOtp: "OTP verifizieren",
      otp: "OTP",
      otpSentToEmail: "Das OTP wurde an Ihre E‑Mail gesendet",
      enterOtp: "OTP eingeben",
      enterOtpHere: "Geben Sie hier das OTP ein",
      verify: "Verifizieren",
      setNewPassword: "Neues Passwort festlegen",
      eightCharLong: "Muss 8 Zeichen lang sein",
      reenterPassword: "Passwort hier erneut eingeben",
      signInAs: "Anmelden als",
      as: "Als",
      selectAccountToProceed: "Wählen Sie ein Konto, um fortzufahren",
      personalAccount: "Privatkonto",
      asBusinessCustomer: "Als Geschäftskunde",
      asDriver: "Als Fahrer",
      enterPassword: "Passwort hier eingeben",
      registerAs: "Registrieren als",
      individual: "Einzelperson",
      business: "Geschäftlich",
      operatorMandatedCustomerCheck:
        "Der Betreiber hat eine Kundenprüfung vorgeschrieben, bevor Sie eine bestätigte Buchung erhalten. Bitte warten Sie auf die Genehmigung.",
      createAccount: "Konto erstellen",
      emailedHowToGetStarted:
        "Wir haben Ihnen eine Anleitung per E‑Mail gesendet.",
      ifDontSeeEmail:
        "Wenn Sie die E‑Mail in wenigen Minuten nicht sehen, prüfen Sie Ihren Spam‑Ordner.",
      previousVehicleDetails: "Details zum vorherigen Fahrzeug",
      registration: "Zulassung",
      makeModel: "Marke/Modell",
      vin: "Fahrgestellnummer (VIN)",
      driverAssigned: "Fahrer zugewiesen",
      currentVehicleDetails: "Aktuelle Fahrzeugdetails",
      priceGroup: "Preisklasse",
      unlimitedMileage: "Unbegrenzte Kilometer",
      paymentStatus: "Zahlungsstatus",
      invoiceNumber: "Rechnungsnummer",
      deliveryDetails: "Lieferdetails",
      collectionDetails: "Abholdetails",
      coiDetails: "COI‑Details",
      policyName: "Policenname",
      planName: "Planname",
      policyNumber: "Policennummer",
      provider: "Anbieter",
      vehicleSwapDetails: "Fahrzeugtausch‑Details",
      swapMyCar: "Auto tauschen",
      NoOfSwapsAllowed: "Erlaubte Tauschvorgänge",
      NoOfSwapsAvailed: "Genutzte Tauschvorgänge",
      NoOfSwapsRemaining: "Verbleibende Tauschvorgänge",
      swapRequestHistory: "TAUSCHANFRAGE‑VERLAUF",
      requestedOn: "ANGEFORDERT AM",
      swapDate: "TAUSCHDATUM",
      oldVehicle: "Altes Fahrzeug",
      newVehicle: "Neues Fahrzeug",
      addonsDetails: "Zusatzoptionen‑Details",
      paymentDetails: "Zahlungsdetails",
      billingPeriod: "Abrechnungszeitraum",
      creationDate: "Erstellungsdatum",
      invoiceType: "Rechnungstyp",
      regular: "Regulär",
      depositDetails: "Anzahldetails",
      amount: "Betrag",
      totalPaidAmount: "Gesamtbetrag bezahlt",
      cancellationCharges: "Stornierungsgebühren",
      totalRefundAmount: "Gesamtrückerstattung",
      anUnpaid: "eine unbezahlte",
      aPartiallyPaid: "teilweise bezahlte",
      thisIs: "Dies ist",
      pleaseContactUs: "Bitte kontaktieren Sie uns bei Fragen",
      reasonToCancelTheBooking: "Bitte wählen Sie einen Stornierungsgrund",
      enterTheReason: "Geben Sie den Grund ein",
      dismiss: "Verwerfen",
      selectVehicle: "Fahrzeug auswählen",
      bookingConfirmationInProgress: "Buchungsbestätigung läuft",
      pleaseProvideTheReason: "Bitte geben Sie den Grund an",
      quote: "Angebot",
      management: "Verwaltung",
      pickupDateTimePassed:
        "Abholzeitpunkt liegt in der Vergangenheit oder es ist null €",
      profileRejectedOrPending:
        "Ihr Profil wurde abgelehnt oder ist noch ausstehend",
      testDriveAgreement: "Testfahrt‑Vereinbarung",
      rentalAgreement: "Mietvertrag",
      contractHireAgreement: "Vertragsmietvertrag",
      subscriptionAgreement: "Abonnement‑Vereinbarung",
      zeroChargeBooking:
        "Null‑€‑Buchung kann nur vom Betreiber bestätigt werden",
      pickupDateTimeInPast: "Abholzeitpunkt liegt in der Vergangenheit",
      creditNoteSummary: "Gutschrift‑Übersicht",
      customerName: "Kundenname",
      customerEmail: "Kunden‑E‑Mail",
      creditNoteRef: "Gutschrifts‑Ref.",
      invoiceRef: "Rechnungs‑Ref.",
      totalAmount: "Gesamtbetrag",
      amountAdjustedRefunded: "Angepasster/Rückerstatteter Betrag",
      amountAvailable: "Verfügbarer Betrag",
      adjustments: "Anpassungen",
      particulars: "Einzelheiten",
      adjustedToInvoice: "Auf Rechnung angerechnet",
      adjustedAt: "Angepasst am",
      creditNotes: "Gutschriften",
      availableBalance: "Verfügbares Guthaben",
      searchCreditNoteId: "Gutschrift‑ID suchen",
      active: "Aktiv",
      exhausted: "Erschöpft",
      creditNoteId: "Gutschrift‑ID",
      dateGenerated: "Erstellungsdatum",
      amountRefunded: "Rückerstattet",
      amountRemaining: "Verbleibender Betrag",
      dashboard: "Dashboard",
      activeVehiclesCount: "Anzahl aktiver Fahrzeuge",
      totalActiveBookings: "Anzahl aktiver Buchungen",
      totalVehicles: "Gesamtfahrzeuge",
      vehicleChecks: "Fahrzeugprüfungen",
      inProgressBookings: "Laufende Buchungen",
      vehicleChecksCompleted: "Fahrzeugprüfung abgeschlossen",
      vehicleChecksPending: "Fahrzeugprüfung ausstehend",
      dailyBalance: "Tagesbalance",
      totalOutstanding: "Offener Gesamtbetrag",
      UnpaidInvoices: "Unbezahlte Rechnungen",
      regularInvoices: "Reguläre Rechnungen",
      sundryInvoices: "Sonstige Rechnungen",
      addNewDriver: "Neuen Fahrer hinzufügen",
      phoneNo: "Telefon‑Nr.",
      drivingLicenceImage: "Führerscheinfoto",
      licenceIssuedBy: "Führerschein ausgestellt von",
      licenceExpiryDate: "Führerschein‑Ablaufdatum",
      drivingLicenceIssueDate: "Ausgabedatum für Führerschein",
      pcoIssueDate: "Ausstellungsdatum der PCO-Fahrerlizenz",
      dateOfBirth: "Geburtsdatum",
      taskDetailsNotFound: "Aufgabendetails nicht gefunden.",
      bookingRef: "Buchungs‑Ref.",
      rateYourExperience: "Erfahrungsbewertung",
      driverInformation: "Fahrerinformationen",
      saveDrivers: "Fahrer speichern",
      expiry: "Ablauf",
      areYouSureDriver:
        "Sind Sie sicher, dass Sie diesen Fahrer entfernen möchten?",
      drivers: "Fahrer",
      noDriverFound: "Leider wurden keine Fahrer gefunden!",
      invoices: "Rechnungen",
      searchInvoiceId: "Rechnungs‑ID suchen",
      unpaid: "Unbezahlt",
      paid: "Bezahlt",
      void: "Ungültig",
      invoiceId: "Rechnungs‑ID",
      invoiceDate: "Rechnungsdatum",
      balanceDue: "Offener Betrag",
      dueDate: "Fälligkeitsdatum",
      invoiceSummary: "Rechnungsübersicht",
      invoice: "Rechnung",
      sundry: "Verschiedenes",
      addPayment: "Zahlung hinzufügen",
      customerPhoneNumber: "Telefonnummer des Kunden",
      invoiceReference: "Rechnungs‑Referenz",
      period: "Zeitraum",
      invoiceVoidedBy: "Rechnung storniert von",
      invoicePeriod: "Abrechnungsperiode",
      invoiceStatus: "Rechnungsstatus",
      invoiceAmount: "Rechnungsbetrag",
      amountDue: "Zu zahlender Betrag",
      generatedAt: "Erstellt am",
      vehicleRentalCharges: "Fahrzeugmietkosten",
      refundable: "Rückzahlbar",
      date: "Datum",
      thisIsTestCourtsey: "Dies ist ein Test/Höflichkeit",
      invoicesConsolidated: "Rechnungen konsolidiert",
      payments: "Zahlungen",
      exempted: "Ausgenommen",
      pleaseLoginFirst: "Bitte zuerst einloggen",
      account: "Konto",
      tracking: "Verfolgung",
      uploadImages: "Bilder hochladen",
      updateVehicleState: "Fahrzeugstatus aktualisieren",
      vehicleImage: "Fahrzeugbild",
      fuelStatus: "Kraftstoffstatus",
      batteryStatus: "Batteriestand",
      odometerReading: "Tachostand",
      nextServiceDetails: "Details zur nächsten Wartung",
      serviceType: "Art des Service",
      serviceStatus: "Service‑Status",
      appointmentDate: "Termindatum",
      estdCompletionDate: "Geschätztes Abschlussdatum",
      serviceProviderName: "Name des Dienstleisters",
      serviceProviderAddress: "Adresse des Dienstleisters",
      notesForDriver: "Hinweise für den Fahrer",
      exteriorDamages: "Äußere Schäden",
      interiorDamages: "Innenschäden",
      generalChecks: "Allgemeine Kontrollen",
      accessoriesChecks: "Zubehörkontrollen",
      chooseFuelLevel: "Kraftstoffstand wählen",
      lastReported: "Zuletzt gemeldet",
      circumstance: "Umstände",
      title: "Titel",
      damageKind: "Schadensart",
      damageArea: "Schadensbereich",
      referenceNumber: "Referenznummer",
      damageDetail: "Schadensdetail",
      addImage: "Bild hinzufügen",
      addImages: "Bilder hinzufügen",
      done: "Fertig",
      searchExistingDriver: "Bestehenden Fahrer suchen",
      success: "Erfolg",
      assignDriver: "Fahrer zuweisen",
      plate: "Kennzeichen",
      unassigned: "Nicht zugewiesen",
      assigned: "Zugewiesen",
      make: "Marke",
      vehicleAppearOnceAssigned: "Fahrzeuge erscheinen nach Zuweisung!",
      searchVehicle: "Fahrzeug suchen",
      trackingHistoryHrs: "Verlauf (std)",
      telemetryDevice: "Telemetriegerät",
      lastLocation: "Letzter Standort",
      latitude: "Breitengrad",
      longitude: "Längengrad",
      forSelectedPeriod: "Für den ausgewählten Zeitraum:",
      milesDriven: "Gefahrene Meilen",
      engineHours: "Motorstunden",
      fuelUsageLitres: "Kraftstoffverbrauch (l)",
      stoppagehours: "Stillstandszeit (std)",
      chargeStatus: "Ladestatus",
      fuelUsage: "Kraftstoffverbrauch",
      batteryLevel: "Batteriestand",
      speedLimit: "Geschwindigkeitsbegrenzung",
      invalidEmailAddress: "Ungültige E‑Mail‑Adresse",
      unableLoadCompanyDetails:
        "Unternehmensdaten konnten nicht geladen werden",
      bookingConfirmationProgress: "Buchungsbestätigung läuft...",
      doNotHitBack:
        "Bitte nicht zurück, abbrechen oder Browser schließen. Dieser Vorgang kann bis zu 2 Minuten dauern.",
      summary: "Zusammenfassung",

      addNew: "Neu hinzufügen",
      street: "Straße",
      city: "Stadt",
      regionState: "Region/Bundesland",
      country: "Land",
      zipPostalCode: "Postleitzahl",
      cardAuthorizeNowButAmountLater:
        "Karte wird jetzt autorisiert, Betrag wird beim Buchungsbeginn abgebucht",
      saveThisCardForFutureInvoicesBooking:
        "Diese Karte speichern, um zukünftige Rechnungen für diese Buchung zu bezahlen.",
      confirmBookingPayLater: "Buchung bestätigen, später bezahlen",
      confirmBookingAndPayAtPickup: "Jetzt buchen und bei Abholung bezahlen",

      bookingReferenceNumber: "Buchungsreferenznummer",
      pickupDetails: "Abholdetails",
      dropoffDetails: "Rückgabedetails",
      to: "Bis",
      bookingReference: "Buchungsreferenz",
      invoiceStartDate: "Rechnungsbeginn:",
      invoiceEndDate: "Rechnungsende:",
      availableAtLocations: "Verfügbar an Standorten",
      benefits: "Vorteile",
      passportNumber: "Reisepassnummer",
      enterPassportNumber: "Geben Sie Ihre Reisepassnummer ein",
      vehicleSwapRequest: "Fahrzeugtausch-Anfrage",
      checkVehicleAvailability: "Fahrzeugverfügbarkeit prüfen",
      pleaseSelectDateAndSearch:
        "Bitte Datum auswählen und auf Suchen klicken, um Fahrzeugverfügbarkeit zu prüfen",
      noVehicleFoundForSelectedDate:
        "Für das ausgewählte Datum wurde kein Fahrzeug gefunden",
      notes: "Notizen",
      writeYourNoteHere: "Schreiben Sie Ihre Notiz hier",
      updateRequest: "Anfrage aktualisieren",
      generateRequest: "Anfrage erstellen",
      cancelRequest: "Anfrage abbrechen",
      operator: "Operator",
      you: "Sie",
      maximum: "Maximum",
      imagesAreAllowed: "Bilder können hochgeladen werden.",
      dragAndDropFile: "Datei ziehen oder klicken",
      areAllowed: "sind erlaubt",
      cancelBooking: "Buchung stornieren",
      booked: "Gebucht",
      organisation: "Organisation",
      vatNumber: "USt‑Nr.",
      sort: "Sortieren",
      DELETE_DRIVER_DESCRIPTION:
        "Sind Sie sicher, dass Sie den Fahrer löschen möchten?",
      driverActions: {
        "Are you sure you want to delete the driver?":
          "Sind Sie sicher, dass Sie den Fahrer löschen möchten?",
        "Delete Driver": "Fahrer löschen",
      },
      currentInvoiceStatus: {
        PAID: "BEZAHLT",
        UNPAID: "UNBEZAHLT",
        VOID: "UNGÜLTIG",
        "PARTIALLY PAID": "TEILWEISE BEZAHLT",
        DRAFT: "ENTWURF",
      },
      currentBookingStatus: {
        CANCELLED: "STORNIERT",
        COMPLETED: "ABGESCHLOSSEN",
        "CONFIRMATION IN PROCESS": "BESTÄTIGUNG LÄUFT",
        CONFIRMED: "BESTÄTIGT",
        "IN PROGRESS": "IN BEARBEITUNG",
        QUOTE: "ANGEBOT",
        DRAFT: "ENTWURF",
        "REQUIRES APPROVAL": "GENEHMIGUNG ERFORDERLICH",
        DECLINED: "ABGELEHNT"
      },
      minBookingDurationMessage:
        "Die Mindestbuchungsdauer beträgt {{hours}} Stunden. Bitte passen Sie Ihr Abhol- oder Rückgabedatum und die Uhrzeit entsprechend an.",
      maxBookingDurationMessage:
        "Die maximale Buchungsdauer beträgt {{days}} Tage. Bitte passen Sie Ihr Abhol- oder Rückgabedatum und die Uhrzeit entsprechend an.",
      usevaletTypes: {
        Delivery: "Lieferung",
        Collection: "Abholung",
        "Delivery and Collection": "Lieferung und Abholung",
      },
      selectCollectionSlot: "Abholzeitraum auswählen",
      driverUnavailableNote:
        "Hinweis: Fahrer ist nicht verfügbar, bitte kontaktieren Sie den Vermieter.",
      cancellationReasons: {
        "Requirement changed": "Anforderung geändert",
        Price: "Preis",
        Other: "Sonstiges",
      },
      imagePreview: "Bildvorschau",
      markDamage: "Schaden markieren",
      vehicleDamageImages: "Fahrzeugschadensbilder",
      incidentDate: "Unfalldatum",
      incidentTime: "Unfallzeit",
      clear: "Löschen",
      bookingStatus: "Buchungsstatus",
      daysInBooking: "Tage in der Buchung",
      accumulatedDays: "angesammelte Tage",
      endingThisMonth: "In diesem Monat enden",
      creditUtilisation: "Kreditauslastung",
      creditLimit: "Kreditlimit",
      utilized: "Genutzt",
      totalDrivers: "Gesamtfahrer",
      vehiclesAllocated: "Fahrzeuge zugewiesen",
      mileageOverview: "Kilometerübersicht",
      mileageLimitExited: "Kilometerlimit beendet",
      approachingMileageLimits: "Kilometerlimits nähern",
      motReminders: "MOT erinnert",
      totalMotTests: "Gesamt -MOT -Tests",
      healthCheckReminders: "Erinnerungen an Gesundheitsuntersuchungen",
      totalHealthCheckTests: "Gesamtanzahl der Gesundheitschecks",
      failed: "Fehlgeschlagen",
      serviceReminders: "Service -Erinnerungen",
      overdue: "Überfällig",
      totalServiceReminders: "Total Service -Erinnerungen",
      createNewServiceRequest: "Neue Serviceanfrage erstellen",
      serviceDetails: "Servicedetails",
      selectedVehicle: "Ausgewähltes Fahrzeug",
      serviceRequestSelectVehicle: "Fahrzeug auswählen",
      loadingVehicles: "Fahrzeuge werden geladen...",
      noActiveVehiclesFound: "Keine aktiven Fahrzeuge gefunden",
      addDetails: "Details hinzufügen",
      addItems: "Elemente hinzufügen",
      issueType: "Problemtyp",
      issueTypePlaceholder: "z.B. Defektes Schloss",
      descriptionPlaceholder: "z.B. Schloss der vorderen linken Tür",
      uploaded: "Hochgeladen",
      additionalComments: "Zusätzliche Kommentare",
      additionalCommentsPlaceholder: "Fügen Sie weitere Informationen hinzu...",
      submitting: "Wird gesendet...",
      submitRequest: "Anfrage senden",
      serviceRequestNote: "Ihre Anfrage wird von unserem Service-Team überprüft. Sie erhalten eine Benachrichtigung, sobald sie genehmigt wurde oder zusätzliche Informationen erforderlich sind.",
      serviceRequestDetails: "Details der Serviceanfrage",
      createdDate: "Erstellungsdatum",
      estimatedCost: "Geschätzte Kosten",
      requestProgress: "Anfragestatus",
      issuesReported: "Gemeldete Probleme",
      issue: "Problem",
      imageAlt: "Bild",
      serviceProvider: "Dienstleister",
      appointment: "Termin",
      at: "um",
      estimatedCompletion: "Voraussichtlicher Abschluss",
      workToBeDone: "Auszuführende Arbeiten",
      cost: "Kosten",
      totalCost: "Gesamtkosten",
      requestDeclined: "Anfrage abgelehnt",
      communication: "Kommunikation",
      serviceTeam: "Service-Team",
      noCommunicationYet: "Noch keine Kommunikation",
      addMessage: "Nachricht hinzufügen",
      askQuestionPlaceholder: "Stellen Sie eine Frage oder geben Sie zusätzliche Informationen an...",
      sending: "Wird gesendet...",
      sendMessage: "Nachricht senden",
      additionalInformationRequested: "Zusätzliche Informationen angefordert",
      provideFollowingInformation: "Bitte geben Sie die folgenden Informationen an, um Ihre Anfrage zu bearbeiten:",
      yourAnswer: "Ihre Antwort:",
      typeAnswerHere: "Geben Sie hier Ihre Antwort ein...",
      submitAnswers: "ANTWORTEN ABSENDEN",
      approved: "Genehmigt",
      serviceRequests: "Serviceanfragen",
      scheduledServicesTitle: "Geplante Services",
      scheduledServicesBellAria: "Geplante Fahrzeugservices anzeigen",
      noScheduledServices: "Keine geplanten Services",
      approveScheduledServiceSuccess: "Service erfolgreich genehmigt",
      requestChangesSuccess: "Änderungsanfrage zur Genehmigung gesendet",
      requestChanges: "Änderungen anfordern",
      modifyServiceRequest: "Serviceanfrage bearbeiten",
      modifyDetails: "Details bearbeiten",
      vehicleAndCategory: "Fahrzeug und Kategorie",
      cannotModify: "Nicht bearbeitbar",
      appointmentDetails: "Termindetails",
      time: "Uhrzeit",
      scheduledServiceReviewHint: "Bitte überprüfen Sie den geplanten Service. Genehmigen Sie, wenn die Details korrekt sind, oder fordern Sie Änderungen an.",
      approveService: "Service genehmigen",
      jobSheet: "Arbeitsblatt",
      declined: "Abgelehnt",
      lastUpdated: "Zuletzt aktualisiert",
      explainChangesPlaceholder: "Erklären Sie, warum Sie diese Änderungen benötigen...",
      submitChanges: "Änderungen einreichen",
      expenses: "Ausgaben",
      filters: "Filter",
      applyFilters: "Filter anwenden",
      activeFilters: "Aktive Filter",
      newServiceRequest: "Neue Serviceanfrage",
      rowsPerPage: "Zeilen pro Seite:",
      of: "von",
      moreThan: "mehr als",
      searchServiceRequestsPlaceholder: "Suche nach Referenznummer, Fahrzeug oder Status...",
      selectOption: "Wählen Sie eine Option",
      selectMultiple: "Wählen Sie eine oder mehrere Optionen",
      uploadPhoto: "Foto hochladen",
      view: "Ansehen",
      typeYourResponse: "Geben Sie Ihre Antwort ein",
      pleaseSelectServiceType: "Bitte wählen Sie einen Servicetyp",
      pleaseSelectServiceCategory: "Bitte wählen Sie eine Servicekategorie",
      selectServiceType: "Servicetyp auswählen",
      serviceCategory: "Servicekategorie",
      selectServiceCategory: "Servicekategorie auswählen",
      unableToDetermineServiceBranch: "Ihre Servicefiliale konnte nicht ermittelt werden. Bitte versuchen Sie es später erneut.",
      accidentDamageInformation: "Unfall- / Schadensinformationen",
      documentUploads: "Dokumenten-Uploads",
      adHoc: "Ad-Hoc",
      emergency: "Notfall",
      serviceQuestionnaire: "Service-Fragebogen",
      serviceQuestionnaireDescription: "Bitte geben Sie einige zusätzliche Details an, damit unser Service-Team alles im Voraus vorbereiten kann.",
      selectServiceCategoryPrompt: "Wählen Sie eine Servicekategorie aus, um die erforderlichen Fragen für diesen Service anzuzeigen.",
      noServiceQuestionsForType: "Keine zusätzlichen Fragen für diesen Servicetyp. Sie können mit der Anfrage fortfahren.",
      fileUploadGuidance: "JPEG/PNG bis zu 5 MB pro Datei.",
      optionalServiceQuestion: "Optionale Frage — beantworten Sie sie, wenn sie unserem Team hilft.",
      requestCreated: "Anfrage erstellt",
      underReview: "In Prüfung",
      inProgress: "In Bearbeitung",
      photo: "Foto",
      hiThere: "Hallo,",
      serviceRequestDeclinedMessage: "Wir haben Ihre Serviceanfrage geprüft, aber sie konnte derzeit nicht genehmigt werden.",
      whatWeNeed: "Was wir brauchen:",
      declineReasonGeneric: "Dies kann auf fehlende Details, Serviceberechtigung oder andere Genehmigungsbedingungen zurückzuführen sein.",
      declineInstruction: "Bitte überprüfen Sie Ihre Informationen und senden Sie eine neue Anfrage, sobald diese Aktualisierungen vorgenommen wurden.",
      answered: "Beantwortet",
      pendingAnswer: "Wartet auf Antwort",
      requiredField: "Diese Antwort ist erforderlich",
      questionsAnswered: "Fragen beantwortet",
      readyToSubmitChanges: "Bereit zum Senden von Aktualisierungen",
      questionsUpToDate: "Alle Antworten sind auf dem neuesten Stand",
      updateAnyAnswerToResubmit: "Aktualisieren Sie eine Antwort oben, wenn Sie neue Informationen senden müssen.",
      answerTypeText: "Text",
      answerTypeYesNo: "Ja / Nein",
      answerTypeDropdown: "Dropdown",
      answerTypeMultiSelect: "Mehrfachauswahl",
      answerTypeFileUpload: "Foto-Upload",
      pendingApproval: "Ausstehende Genehmigung",
      awaitingMoreInformation: "Warten auf weitere Informationen",
      closed: "Geschlossen",
      noServiceRequestsFound: "Keine Serviceanfragen gefunden",
      fleetAllocation: "Flottenzuweisung",
      fleetAllocations: "Flottenzuweisungen",
      userAgreement: "Nutzervereinbarung",
      organisationCode: "Organisationscode",
      serviceReference: "Service-Referenz",
      completionDate: "Abschlussdatum",
      addTask: "Aufgabe Hinzufügen",
      noTaskFound: "Keine Aufgaben gefunden. Sie können Aufgaben manuell hinzufügen.",
      taskName: "Aufgabenname",
      features: "Funktionen",
      interiorFeatures: "Innenausstattung",
      exteriorFeatures: "Außenausstattung",
      safetyAndTechnicalFeatures: "Sicherheits- und Technikmerkmale",
      otherFeatures: "Weitere Ausstattung",
      privateHiresNo: "Private Hires Nr",
      pcoPrivateHiresHireDLNo: "PCO/Private Hire DL Nr.",
      gender: "Geschlecht",
      secondaryEmailAddress: "Sekundäre E-Mail-Adresse",
      secondaryPhoneNumber: "Sekundäre Telefonnummer",
      driverAge: "Alter des Fahrers",
      licenceDuration: "Lizenzdauer",
      penaltyPoints: "Strafpunkte",
      insuranceClaimsHistory: "Verlauf der Versicherungsansprüche",
      pcoExpiryDate: "PCO -Ablaufdatum",
      state: "Bundesland",
      selectBookingType: "Buchungstyp auswählen",
      selectBookingTypeDialog: "Bitte wählen Sie einen der folgenden Buchungstypen aus, um mit der Buchung fortzufahren",
      regularBooking: "Normale Buchung",
      contactlessBooking: "Kontaktlose Buchung",
      reviewBookingDetails: "Buchungsdetails überprüfen",
    },
    validation: {
      otpLengthMismatch: "Die OTP-Länge muss 6 Zeichen betragen.",
      invalidOtp: "Ungültiges OTP",
      required: "{{field}} ist erforderlich",
      billingEmailInvalid:
        "Bitte geben Sie eine gültige Abrechnungs -E -Mail ein.",
      billingEmailRequired: "Abrechnungs -E -Mail ist erforderlich.",
      phoneNumberRequired: "Telefonnummer ist erforderlich.",
      businessNameRequired: "Firmenname ist erforderlich.",
      registrationNumberRequired: "Registrierungsnummer ist erforderlich",
      vatRequired: "Umsatzsteuer-Identifikationsnummer ist erforderlich",
      accountNumberRequired: "Kontonummer ist erforderlich",
      registeredAddressRequired: "Eine registrierte Adresse ist erforderlich",
      registeredAddressCountryRequired: "Land ist erforderlich",
      registeredAddressStateRequired: "Staat ist erforderlich",
      registeredAddressCityRequired: "Stadt ist erforderlich",
      registeredAddressStreetRequired: "Straße ist erforderlich",
      tradingAddressRequired: "Handelsadresse ist erforderlich",
      tradingAddressCountryRequired: "Land ist erforderlich",
      tradingAddressStateRequired: "Staat ist erforderlich",
      tradingAddressCityRequired: "Stadt ist erforderlich",
      tradingAddressStreetRequired: "Straße ist erforderlich",
      contactEmailRequired: "Kontakt -E -Mail ist erforderlich.",
      firstNameRequired: "Vorname ist erforderlich.",
      middleNameRequired: "Der zweite Vorname ist erforderlich.",
      lastNameRequired: "Nachname ist erforderlich.",
      addressRequired: "Adresse ist erforderlich",
      locationRequired: "Ort ist erforderlich",
      streetZipcodeRequired: "Street/Zipcode ist erforderlich",
      emailIsRequired: "E-Mail ist erforderlich",
      termsConditionsAccepted:
        "Die Allgemeinen Geschäftsbedingungen müssen akzeptiert werden",
      drivingLicenceNumberRequired: "Führerscheinnummer ist erforderlich",
      nationalInsuranceNumberRequired: "Versicherungsnummer ist erforderlich",
      nationalityRequired: "Staatsangehörigkeit ist erforderlich",
      enterValidPhoneNumber: "Bitte geben Sie eine gültige Telefonnummer ein.",
      enterValidEmailAddress: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      authorityRequired: "Behörde ist erforderlich",
      licenceNumberRequired: "Führerscheinnummer ist erforderlich",
      licenceExpiryDateRequired:
        "Ablaufdatum des Führerscheins ist erforderlich",
      expiryDateRequired: "Ablaufdatum ist erforderlich",
      numberIsRequired: "Nummer ist erforderlich",

      passwordLengthValidaion: "Passwortlänge muss ≥ 8 Zeichen sein",
      passwordContainUppercase:
        "Das Passwort muss mindestens einen Großbuchstaben enthalten",
      passwordContainLowercase:
        "Das Passwort muss mindestens einen Kleinbuchstaben enthalten",
      passwordContainOneNumber:
        "Das Passwort muss mindestens eine Zahl enthalten",
      passwordContainSpecialCharacter:
        "Das Passwort muss mindestens ein Sonderzeichen enthalten",
      passwordMustMatch: "Passwörter müssen übereinstimmen",
      atleastOneUppercase: "Mindestens ein Großbuchstabe",
      atleastOneLowercase: "Mindestens ein Kleinbuchstabe",
      atleastOneNumericalChar: "Mindestens eine Zahl",
      atleastOneSpecialChar: "Mindestens ein Sonderzeichen",
      pleaseEnterAValidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      driverNotFound: "Fahrer nicht gefunden",
      batteryStatusNumber: "Batteriestatus muss eine Zahl sein",
      batteryStatusCantNegative: "Batteriestatus darf nicht negativ sein",
      batteryStatusCantMoreHundred:
        "Batteriestatus darf 100% nicht überschreiten",
      batteryStatusRequired: "Batteriestatus ist erforderlich",
      odometerReadingMustNumber: "Kilometerstand muss eine Zahl sein",
      odometerReadingRequired: "Kilometerstand ist erforderlich",
      odometerMustEqualOrHigherLast:
        "Kilometerstand muss gleich oder höher als der letzte Wert sein",
      titleIsRequired: "Titel ist erforderlich.",
      damageKindIsRequired: "Schadensart ist erforderlich.",
      descriptionIsRequired: "Beschreibung ist erforderlich.",
      damageImageIsRequired: "Schadensbild ist erforderlich.",
      professionIsRequired: "Beruf ist erforderlich",
      passportNineCharacters: "Die Passnummer muss von 9 Zeichen sein",
      passportIsRequired: "Pass ist erforderlich",
      organisationCodeRequired: "Organisationscode ist erforderlich",
      userNotFound: "Benutzer nicht gefunden",
      invalidPassword: "Ungültiges Passwort",
      passwordLengthError: "Das Passwort muss mindestens 8 Zeichen lang sein",
      customerPCONumberRequired: "Die PCO-/Private-Hire-Lizenznummer ist erforderlich",
      genderRequired: "Geschlecht ist erforderlich",
    },
    misc: {
      edit: "Bearbeiten",
      logOut: "Abmelden",
      licence: "Lizenz",
      cancel: "Abbrechen",
      save: "Speichern",
      status: {
        PENDING: "Ausstehend",
        APPROVED: "Genehmigt",
        DECLINED: "Abgelehnt",
        IN_REVIEW: "In Überprüfung",
      },
      delete: "Löschen",
      create: "Erstellen",
      signIn: "Anmelden",
      select: "Auswählen",
      back: "Zurück",
      error: "Fehler",
      yes: "Ja",
      no: "Nein",
      payConfirm: "Bezahlen & Bestätigen",
      clickToAdd: "Zum Hinzufügen klicken",
      close: "Schließen",
      download: "Herunterladen",
      selectCaps: "AUSWÄHLEN",
      forgotPassword: "Passwort vergessen",
      pleaseNote: "Bitte beachten",
      front: "Vorderseite",
      columnKey: {
        "#": "#",
        Particulars: "Einzelheiten",
        Quantity: "Menge",
        "Unit Price": "Stückpreis",
        Duration: "Dauer",
        "Discounted Price": "Ermäßigter Preis",
        "VAT/TAX": "MwSt./Steuer",
        Amount: "Betrag",
      },
      columnLabelToKeyMap: {
        ITEM: "ARTIKEL",
        DESCRIPTION: "BESCHREIBUNG",
        QUANTITY: "MENGE",
        "UNIT PRICE": "STÜCKPREIS",
        DURATION: "DAUER",
        "DISCOUNTED PRICE": "RABATTIERTER PREIS",
        "VAT/TAX": "MwSt./STEUER",
        PRICE: "PREIS",
      },
      paymentColumnsKey: {
        Date: "Datum",
        Amount: "Betrag",
        "Mode Of Payments": "Zahlungsmethode",
        Status: "Status",
      },
      consolidatedInvoicesColumnsKey: {
        "#": "#",
        "Invoice Reference Number": "Rechnungsnummer",
        "Vehicle Registration Numbers": "Fahrzeugzulassungsnummer(n)"
      },
      buttonKey: {
        Rentals: "Mieten",
        Subscriptions: "Abonnements",
        "Test Drive": "Probefahrt",
        "Contract Hire": "Mietvertrag",
      },
      subLabelKey: {
        "Book vehicle for hours and days":
          "Fahrzeug stunden- oder tageweise buchen",
        "Subscribe vehicle for weekly/monthly":
          "Fahrzeug wöchentlich/monatlich abonnieren",
        "Test Drive our Premium Vehicles": "Testen Sie unsere Premiumfahrzeuge",
        "Contract Hire vehicle for weekly/monthly":
          "Fahrzeug wöchentlich/monatlich per Vertrag mieten",
      },
      buttonTextKey: {
        "Subscribe Now": "Jetzt abonnieren",
        "Book Now": "Jetzt buchen",
        "Contract Now": "Jetzt mieten",
      },
      featuresKey: {
        "Flexible Leasing Options": "Flexible Leasing-Optionen",
        "Choose the duration of your subscription as you go":
          "Wählen Sie die Dauer Ihres Abonnements flexibel",
        "Change car anytime*": "Auto jederzeit wechseln*",
        "Home delivery option": "Option für Hauszustellung",
        "100% digital": "100 % digital",
        "MOT and taxes": "TÜV und Steuern",
        "Without down payment": "Ohne Anzahlung",
        "Vehicle Servicing": "Fahrzeugwartung",
      },
      adjustmentColumnKey: {
        "#": "#",
        Amount: "Betrag",
        "Adjusted To Invoice": "An Rechnung angepasst",
        "Adjusted At": "Angepasst am",
      },
      categoriesKey: {
        Knowledge: "Wissen",
        Behavior: "Verhalten",
        Punctuality: "Pünktlichkeit",
      },
    },

    snackBar: {
      customerInfoSaved: "Kundeninformationen gespeichert",
      documentDeleted: "Dokument erfolgreich gelöscht",
      documentDeleteFailed: "Dokument nicht löschen",
      documentDeleteError: "Fehler löschen Dokument",
      documentMarkedForDeletion:
        "Dokument jest oznaczony do usunięcia. Zmiany zostaną zastosowane po zapisaniu. ",
      profileImageUploaded: "Profilbild erfolgreich hochgeladen",
      uploadImageFormatError:
        "Bitte laden Sie nur .jpeg/.jpg/.png Bildformat hoch!",
      selectDocumentType: "Bitte wählen Sie Dokumenttyp",
      selectExpiryDate: "Bitte wählen Sie das Ablaufdatum des Dokuments aus",
      fileSizeExceeded50mb:
        "Die Dateigröße hat eine Grenze von 50 MB überschritten",
      fileSizeExceeded5mb:
        "Die Dateigröße hat eine Grenze von 5 MB überschritten",
      uploadSuccess: "Dokument erfolgreich hochgeladen",
      invalidUploadFormat:
        "Bitte laden Sie nur PDF-, PNG-, JPG- oder JPEG -Dateien hoch",
      selectExpiryDateUpload:
        "Bitte wählen Sie vor dem Hochladen ein Ablaufdatum.",
      ImageUploaded: "Bild erfolgreich hochgeladen",
      invalidFileType: "Ungültiger Dateityp. Zulässige Typen: jpeg oder png",
      costCenterInfoMissing: "Kostenstelleninformationen fehlen!",
      selectedDriverAlreadyAdded: "Ausgewählter Fahrer bereits hinzugefügt.",
      driverSavedSuccessfully: "Fahrer erfolgreich gespeichert.",
      additionalDriverCannotBeMore:
        "Zusätzliche Fahrer dürfen die Addon-Menge nicht überschreiten",
      verificationStatusInReview: "Überprüfungsstatus wird geprüft",
      verificationStatusPending: "Überprüfungsstatus steht aus",
      quoteCreated: "Angebot erstellt",
      bookingCreated: "Buchung erstellt",
      pickUpLocationEmpty: "Abholort ist leer",
      slotSelectionRequiredForNonNegotiable:
        "Die Slot-Auswahl ist erforderlich.",
      protectionPlanMandatoryForPCOBooking:
        "Schutzplan ist für diese Buchung obligatorisch",
      paymentAlreadyDone: "Zahlung bereits erfolgt",
      fileBeingGenerated:
        "Datei wird erstellt, bitte versuchen Sie es später erneut",
      provideDeliveryAddress: "Bitte geben Sie die Lieferadresse an!",
      noValidCreditReadingFound:
        "Keine gültige Kreditbewertung für dieses Unternehmen gefunden.",
      noValidCreditScoreFound:
        "Keine gültige Kreditwürdigkeit gefunden. Möglicherweise wurde die Anzahl der Kreditprüfungen überschritten.",
      atleastOneLicenceImage: "Laden Sie mindestens ein Führerscheinbild hoch",
      licenceImageUploaded: "Führerscheinbild erfolgreich hochgeladen",
      maximumTwoImageLicence:
        "Maximal zwei Bilder können für den Führerschein hochgeladen werden!",
      imageUploadInProgress: "Bitte warten, Bild wird hochgeladen!",
      errorFetchingSignedUrl: "Fehler beim Abrufen der signierten URL",
      paymentFailed: "Zahlung fehlgeschlagen, bitte versuchen Sie es erneut",
      paymentFailedReasonCardDetails:
        "Ihre Zahlung ist fehlgeschlagen! Bitte überprüfen Sie Ihre Kartendaten oder versuchen Sie es später erneut.",
      maximumTwoImage: "Maximal zwei Bilder können hochgeladen werden für",

      cancelledSuccessfully: "Erfolgreich storniert",
      selectReasonForCancel: "Bitte geben Sie den Stornierungsgrund ein",
      streetZipcodeRequired: "Straße / Postleitzahl ist erforderlich",
      feedbackSaved: "Danke! Ihr Feedback wurde gespeichert",
      driverAlreadyAdded: "Fahrer wurde bereits hinzugefügt!",
      driverRemoved: "Fahrer erfolgreich entfernt",
      businessCustomerDriverDeleted: "Geschäftskundenfahrer gelöscht.",
      errorInSavingData: "Fehler beim Speichern der Daten",
      damageInformationSaved: "Schadensinformationen erfolgreich gespeichert.",
      errorSavingData: "Fehler beim Speichern der Daten",
      problemTelematicsData: "Problem beim Laden der Telematikdaten",
      verificationRequestSent: "Verifizierungsanfrage erfolgreich gesendet.",
      vehicleStateUpdated: "Fahrzeugstatus aktualisiert",
      driverAdded: "Fahrer hinzugefügt.",
      businessCustomerCreated: "Geschäftskunde erstellt.",
      uploadOnlyImageFiles: "Bitte laden Sie nur Bilddateien hoch (PNG, JPEG, JPG)",
      imageSizeExceed5MB: "Die Bildgröße sollte 5 MB nicht überschreiten",
      uploadFailed: "Upload fehlgeschlagen",
      imagesUploadedSuccessfully: "Bild(er) erfolgreich hochgeladen!",
      failedToUploadImages: "Fehler beim Hochladen der Bilder. Bitte versuchen Sie es erneut.",
      pleaseSelectVehicle: "Bitte wählen Sie ein Fahrzeug aus",
      pleaseFillInAllIssueDetails: "Bitte füllen Sie alle Problemdetails aus",
      serviceRequestCreatedSuccessfully: "Serviceanfrage erfolgreich erstellt! Referenz:",
      errorCreatingServiceRequest: "Fehler beim Erstellen der Serviceanfrage",
      pleaseEnterNote: "Bitte geben Sie eine Notiz ein",
      noteAddedSuccessfully: "Notiz erfolgreich hinzugefügt",
      errorAddingNote: "Fehler beim Hinzufügen der Notiz",
      pleaseAnswerAllRemainingQuestions: "Bitte beantworten Sie alle {{count}} verbleibenden Frage{{plural}}",
      answersSubmittedSuccessfully: "Antworten erfolgreich übermittelt! Ihre Anfrage wird nun geprüft.",
      errorSubmittingAnswers: "Fehler beim Übermitteln der Antworten",
      serviceRequestNotFound: "Serviceanfrage nicht gefunden",
      errorLoadingServiceRequests: "Fehler beim Laden der Serviceanfragen",
      oneVehicleForContactless: "Für eine kontaktlose Buchung kann nur ein Fahrzeug ausgewählt werden",
      oneVehicleForNonContactless: "Für eine kontaktlose Buchung kann nur ein kontaktloses oder Smartcar-Fahrzeug ausgewählt werden",
      contactlessVehicleCannotBeSelected: "Ein kontaktloses Fahrzeug kann nicht für reguläre Buchungen ausgewählt werden",
      bookingDetailsCreated: "Buchungsdetails erstellt"
    },
  },
};